/**
 * Screen 3 — the main menu, eight colour tiles.
 *
 * Each tile carries the colour of the area it leads to, and that area keeps
 * the colour on every screen inside it. The tiles a member cannot use yet
 * (stages 2 and 3) are rendered disabled rather than hidden: a menu that
 * changes shape as the app grows teaches nobody where anything is.
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Shell, type Area } from "../components/Shell";
import { api, isSignedIn, type Me } from "../lib/api";

const TILES: { area: Area; key: string; to: string | null }[] = [
  { area: "home", key: "nav.home", to: "/" },
  { area: "programs", key: "nav.programs", to: "/programs" },
  { area: "bookings", key: "nav.bookings", to: "/bookings" },
  { area: "membership", key: "nav.membership", to: null },
  { area: "news", key: "nav.news", to: null },
  { area: "calendar", key: "nav.calendar", to: null },
  { area: "profile", key: "nav.profile", to: "/profile" },
  { area: "about", key: "nav.about", to: null },
];

export default function Menu() {
  const { t } = useTranslation();
  const [me, setMe] = useState<Me | null>(null);

  useEffect(() => {
    if (isSignedIn()) api.me().then(setMe).catch(() => undefined);
  }, []);

  return (
    <Shell masthead="menu.jpg" area="home" title={t("app.name")}>
      <div className="tiles">
        {TILES.map((tile) =>
          tile.to ? (
            <Link key={tile.key} to={tile.to} data-area={tile.area} className="tile">
              {t(tile.key)}
            </Link>
          ) : (
            <span key={tile.key} data-area={tile.area} className="tile tile--soon" aria-disabled>
              {t(tile.key)}
            </span>
          ),
        )}
        {/* Only for someone who actually holds a role. The API refuses the
            rest either way; this is so a member is not shown a door they
            cannot open. */}
        {!isSignedIn() && (
          <Link to="/signin" data-area="membership" className="tile">
            {t("auth.sign_in")}
          </Link>
        )}
        {me?.roles.length ? (
          <Link to="/admin" data-area="danger" className="tile">
            {t("admin.dashboard")}
          </Link>
        ) : null}
      </div>
    </Shell>
  );
}
